<template>
  <div>
    <el-dialog :visible.sync="dlg_login_model" :close-on-click-modal="true" @close="dialogClose" width="500px">
      <div class="single-card">
        <div class="single-card-title">
          <a href='/' class="m-5">
            <span class="datawill-logo-text2">登录系统</span>
          </a></div>
        <div v-if="useMobile==true">
          <div class="single-card-subtitle"> 通过你的手机验证码登录,
            或 <a href="javascript:;" @click="useMobile=false">账号密码</a></div>
          <div class="form-group">
            <label class="form-label"> 手机号 </label>
            <div thysize="lg" class="thy-input form-control">
              <div class="input-prepend">
                <a href="javascript:;"><span>中国+86</span><i href="javascript:;"></i></a>
              </div>
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg form-control" placeholder="请输入手机号" autocomplete="false"
                     v-model="loginForm.mobile">
            </div>
          </div>
          <div class="form-group">
            <label class="form-label"> 手机验证码 </label>
            <div thysize="lg" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg form-control "
                     autocomplete="off" placeholder="请输入短信验证码" v-model="loginForm.validateCode">
              <div class="input-append">
                <button class="font-size-sm btn btn-primary btn-sm btn-square" thybutton="primary-square"
                        v-on:click="sendSMS()"
                        thysize="sm">
                  获取短信验证码
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="single-card-subtitle"> 通过你的账号密码登录,
            或 <a href="javascript:;" @click="useMobile=true">手机验证码</a></div>
          <div class="form-group">
            <label class="form-label"> 用户名 </label>
            <div thysize="lg" pattern="/^(\+?0086\-)?1[3456789]\d{9}$/" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg form-control" placeholder="请输入用户名"
                     v-model="loginForm.username">
            </div>
          </div>

          <div class="form-group">
            <label class="form-label"> 密码 </label>
            <div thysize="lg" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg form-control" placeholder="请输入密码" type="password"
                     v-model="loginForm.password">
            </div>
          </div>
          <div class="form-group">
            <label class="form-label"> 验证码 </label>
            <div thysize="lg" class="thy-input form-control">
              <span class="input-label input-label-lg"></span>
              <input class="form-control-lg  form-control" placeholder="请输入验证码"
                     v-model="loginForm.validateCode">
              <div class="">
                <el-image :src="captcha_url" @click="get_captcha"/>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <div></div>
        </div>
        <div class="single-card-actions form-group">
          <div class="form-group-footer form-group-footer-align-left">
            <div class="btn-pair form-footer-actions">
              <button class="btn-block single-btn lg-btn btn btn-primary btn-square" v-on:click="handleLogin">登录
              </button>
              <div class="single-card-actions-desc"> 或 <a href="javascript:;" @click="signup">创建账号</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from '../api/rest'
import util from '../api/util'

export default {
  props: {
    dlg_login_model: Boolean,
  },
  data() {
    return {
      msg: 'messagge',
      logining: false,
      isMobile: false,
      useMobile: true,
      loginForm: {
        mobile: '',
        sms: '',
        username: '',
        password: '',
        validateCode: ''
      },
      captcha_url: api.setting.getApiUrl() + "/captcha",
      rules: util.setting.getRules(),
    }
  },
  methods: {
    get_captcha() {
      this.captcha_url = api.setting.getApiUrl() + "/captcha?id=" + Math.random();
    },
    forgetPasswd() {
      this.$message({
        message: '请联系系统管理员',
        type: 'info'
      })
    },
    handleRegister() {
      window.location = '#/register'
    },
    signup() {
      this.$message({
        message: '无需注册，请使用手机接收验证码登录。',
        type: 'info'
      })
    },
    sendSMS() {
      // console.log(this.loginForm.mobile)
      let param = {
        mobile: this.loginForm.mobile,
        code: this.loginForm.validateCode
      }
      let api_url = "/sendCode"
      api.remote.doPost(param, api_url).then((res) => {
        this.$message({
          message: res.message,
          type: 'success'
        })
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
    handleLogin() {
      if (this.isMobile) {
        this.$message({
          message: '手机无法登录，请使用PC浏览器',
          type: 'error'
        })
        return
      }
      api.profile.clear()
      let user = {}
      if (this.useMobile == true) {
        user = {
          mobile: this.loginForm.mobile,
          code: this.loginForm.validateCode
        }
      } else {
        user = {
          username: this.loginForm.username,
          password: this.loginForm.password,
          code: this.loginForm.validateCode
        }
      }
      let api_url = "/session?code=" + this.loginForm.validateCode
      api.remote.doPost(user, api_url).then((resp) => {
        console.log(resp)
        if (resp.item != null) {
          let data = resp.item
          api.profile.setUser(data)
          this.dialogClose()
        }
      }).catch((res) => {
        this.$message({
          title: res.title,
          message: res.message,
          type: res.status
        })
        api.handError.action(this, res)
      })
    },
    dialogClose() {
      // this.dlg_login_model = false;
      this.$emit("loginClose", this.dlg_login_model);
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>


// WEBPACK FOOTER //
// LoginDialog.vue?80d53d0a